import React, { useState, useEffect, useRef, useMemo } from 'react';
import { 
    FolderOpen, 
    FileText, 
    Upload, 
    Download, 
    Search, 
    Filter, 
    Grid, 
    List, 
    MoreVertical, 
    Star, 
    Trash2, 
    Share2, 
    Eye, 
    Calendar,
    User,
    HardDrive,
    Cloud,
    Shield,
    Plus,
    ChevronRight,
    Home,
    Settings,
    LogOut,
    Bell,
    Menu,
    X,
    RefreshCw,
    FolderPlus,
    AlertCircle,
    Edit,
    Move,
    Copy,
    CheckCircle,
    XCircle
  } from 'lucide-react';

// Filter Panel Component
export const FilterPanel = ({ filters, setFilters, onClose }) => {
    const fileTypes = [
      { value: '', label: 'All Files' },
      { value: 'image', label: 'Images' },
      { value: 'document', label: 'Documents' },
      { value: 'spreadsheet', label: 'Spreadsheets' },
      { value: 'presentation', label: 'Presentations' },
      { value: 'video', label: 'Videos' },
      { value: 'audio', label: 'Audio' },
      { value: 'archive', label: 'Archives' },
      { value: 'other', label: 'Other' }
    ];
  
    const dateRanges = [
      { value: '', label: 'Any time' },
      { value: 'today', label: 'Today' },
      { value: 'week', label: 'This week' },
      { value: 'month', label: 'This month' }
    ];
  
    return (
      <div className="absolute top-full right-0 mt-2 bg-white shadow-lg rounded-lg border border-gray-200 p-4 z-50 min-w-64">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-semibold text-gray-900">Filters</h3>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded">
            <X className="h-4 w-4" />
          </button>
        </div>
  
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">File Type</label>
            <select
              value={filters.fileType}
              onChange={(e) => setFilters(prev => ({ ...prev, fileType: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              {fileTypes.map(type => (
                <option key={type.value} value={type.value}>{type.label}</option>
              ))}
            </select>
          </div>
  
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Date Modified</label>
            <select
              value={filters.dateRange}
              onChange={(e) => setFilters(prev => ({ ...prev, dateRange: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              {dateRanges.map(range => (
                <option key={range.value} value={range.value}>{range.label}</option>
              ))}
            </select>
          </div>
  
          <div>
            <label className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={filters.starred}
                onChange={(e) => setFilters(prev => ({ ...prev, starred: e.target.checked }))}
                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              />
              <span className="text-sm font-medium text-gray-700">Starred only</span>
            </label>
          </div>
  
          <div className="pt-2 border-t border-gray-200">
            <button
              onClick={() => setFilters({ search: '', fileType: '', dateRange: '', starred: false })}
              className="text-sm text-blue-600 hover:text-blue-700"
            >
              Clear all filters
            </button>
          </div>
        </div>
      </div>
    );
  };